import React from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

export default function HomeScreen() {
  const getUserInfo = useSelector((state) => state.getUserInfo);

  const location = useLocation();

  const history = useHistory();

  const onClickRoute = (url) => {
    if (location.pathname !== url) {
      history.push(url);
    }
  };

  return (
    <div className="row">
      <div className="col-sm-12">
        <div className="textBox">
          <div className="content">Saha Uygulaması</div>
        </div>
      </div>
      <div className="col-sm-12">
        <div className="textBox">
          <div className="content" style={{ fontSize: "17px" }}>
            <div style={{ borderBottom: "1px solid gray" }}>Yapılabilecek İşlemler</div>
            <div style={{ fontSize: "12px" }}>
              {getUserInfo.Rol.includes("9") && (
                <div
                  style={{
                    backgroundColor: "#f5bc25",
                    color: "black",
                    cursor: "pointer",
                    borderRadius: "10px",
                    margin: "5px",
                    fontSize: "15px",
                    padding: 5,
                    paddingLeft: 15,
                  }}
                  onClick={() => onClickRoute("/dashboard/statics")}
                >
                  <div className="d-flex justify-content-between">
                    İstatistikler <i className="fas fa-angle-double-right fa-lg" style={{ marginTop: "4px" }}></i>{" "}
                  </div>
                </div>
              )}
              {getUserInfo.Rol.includes("7") && (
                <div
                  style={{
                    backgroundColor: "#f5bc25",
                    color: "black",
                    cursor: "pointer",
                    borderRadius: "10px",
                    margin: "5px",
                    fontSize: "15px",
                    padding: 5,
                    paddingLeft: 15,
                  }}
                  onClick={() => onClickRoute("/dashboard/hsign")}
                >
                  <div className="d-flex justify-content-between">
                    Levha-Numarataj <i className="fas fa-angle-double-right fa-lg" style={{ marginTop: "4px" }}></i>{" "}
                  </div>
                </div>
              )}
              {getUserInfo.Rol.includes("8") && (
                <div
                  style={{
                    backgroundColor: "#f5bc25",
                    color: "black",
                    cursor: "pointer",
                    borderRadius: "10px",
                    margin: "5px",
                    fontSize: "15px",
                    padding: 5,
                    paddingLeft: 15,
                  }}
                  onClick={() => onClickRoute("/dashboard/sign")}
                >
                  <div className="d-flex justify-content-between">
                    Direk/Duvar <i className="fas fa-angle-double-right fa-lg" style={{ marginTop: "4px" }}></i>{" "}
                  </div>
                </div>
              )}
              {getUserInfo.Rol.includes("7") && (
                <div
                  style={{
                    backgroundColor: "#f5bc25",
                    color: "black",
                    cursor: "pointer",
                    borderRadius: "10px",
                    margin: "5px",
                    fontSize: "15px",
                    padding: 5,
                    paddingLeft: 15,
                  }}
                  onClick={() => onClickRoute("/dashboard/data")}
                >
                  <div className="d-flex justify-content-between">
                    Veri Yönetimi <i className="fas fa-angle-double-right fa-lg" style={{ marginTop: "4px" }}></i>{" "}
                  </div>
                </div>
              )}
              {getUserInfo.Rol.includes("133") && (
                <div
                  style={{
                    backgroundColor: "#f5bc25",
                    color: "black",
                    cursor: "pointer",
                    borderRadius: "10px",
                    margin: "5px",
                    fontSize: "15px",
                    padding: 5,
                    paddingLeft: 15,
                  }}
                  onClick={() => onClickRoute("/dashboard/team")}
                >
                  <div className="d-flex justify-content-between">
                    Ekip Yönetimi <i className="fas fa-angle-double-right fa-lg" style={{ marginTop: "4px" }}></i>{" "}
                  </div>
                </div>
              )}
              {getUserInfo.Rol.includes("6") && (
                <div
                  style={{
                    backgroundColor: "#f5bc25",
                    color: "black",
                    cursor: "pointer",
                    borderRadius: "10px",
                    margin: "5px",
                    fontSize: "15px",
                    padding: 5,
                    paddingLeft: 15,
                  }}
                  onClick={() => onClickRoute("/dashboard/config")}
                >
                  <div className="d-flex justify-content-between">
                    Uygulama Yönetimi <i className="fas fa-angle-double-right fa-lg" style={{ marginTop: "4px" }}></i>{" "}
                  </div>
                </div>
              )}
              {getUserInfo.Rol.includes("5") && (
                <div
                  style={{
                    backgroundColor: "#f5bc25",
                    color: "black",
                    cursor: "pointer",
                    borderRadius: "10px",
                    margin: "5px",
                    fontSize: "15px",
                    padding: 5,
                    paddingLeft: 15,
                  }}
                  onClick={() => onClickRoute("/dashboard/users")}
                >
                  <div className="d-flex justify-content-between">
                    Kullanıcı Yönetimi <i className="fas fa-angle-double-right fa-lg" style={{ marginTop: "4px" }}></i>{" "}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
